import { render, staticRenderFns } from "./tOptions.vue?vue&type=template&id=ac6cddfa&scoped=true&"
import script from "./tOptions.vue?vue&type=script&lang=js&"
export * from "./tOptions.vue?vue&type=script&lang=js&"
import style0 from "./tOptions.vue?vue&type=style&index=0&id=ac6cddfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac6cddfa",
  null
  
)

export default component.exports